const filtersMixin = {

    methods: {

        onlyNumber(e) {

            const evt = (e || window.event);

            const charCode = (evt.which) ? evt.which : evt.keyCode;

            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {

                evt.preventDefault();

            }

            return true;

        },

    },

    filters: {

        phoneFilter(value) {

            if (value) {

                return value.replace(/[^0-9]/g, '')
                    .replace(/(\d{3})(\d{3})(\d{4})/, '$1 $2 $3');

            }

            return null;

        },

        nameLengthFilter(value) {

            const clamp = ' ...';
            return value.length > 32 ? value.slice(0, 32) + clamp : value;

        },

        moneyFilter(value) {

            return !Number.isNaN(Number(value))
                ? Intl.NumberFormat('en-US', {
                    style: 'currency',
                    // currency: 'COP',
                    currency: 'USD',
                    currencyDisplay: 'symbol',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(value)
                : 0;

        },

        numberFilter(value) {

            return Intl.NumberFormat('en-US').format(value);

        },

        nameFilter(value) {

            return value.split(' ')[0];

        },

    },

};

export default filtersMixin;
